<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length>0?'dialog-scroller':'']" style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="templatePointFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple
                 accept=".xlsx, .xls" @change="handleClick">
          <el-button :loading="loading" size="mini" type="primary" icon="el-icon-document-add"
                     @click="exportModel">
            {{ $t('xiazaimuban') }}
          </el-button>
          <el-button :loading="loading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{ $t('piliangshangchuan') }}
          </el-button>

          <download-excel
              ref="downloadBtn"
              :fields="json_fields"
              type="xls"
              :name="excelName"
              style="position:absolute;z-index: -999"
              :data="allData">
            <el-button class="" type="primary">
              <div class="btn_space">
                <span>导出</span>
              </div>
            </el-button>
          </download-excel>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
					<span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
						<i class="el-icon-link"/>
						<span>{{ item }}</span>
						<i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)"/>
					</span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
          <el-table :max-height="tableHeight" :data="
              tableData.slice(
                (pagination.currentPage - 1) * pagination.pageSize,
                pagination.currentPage * pagination.pageSize
              )
            " border size="mini" :header-cell-style="{
              color: '#606266',
              'font-weight': '700',
              height: '48px',
              padding: '0px',
            }">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop"
                             :label="item.label">
              <template slot-scope="scope">
								<span>{{
                    scope.row[item.prop] === "" ? "-" : scope.row[item.prop]
                  }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length>0" style=" display: flex; flex-direction: row-reverse"
                         background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                         :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next"
                         :total="tableData.length" @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="default" size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
				<el-button type="primary" size="mini" @click="importData">{{ $t('baocun') }}</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import downloadExcel from 'vue-json-excel'

export default {
  components: {
    downloadExcel
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    templateId: Number,
    customerId: Number
  },
  data() {
    return {
      loading: false,
      excel: [],
      tableData: [],
      tableHeight: 0,
      allData: [],
      excelName: '',
      json_fields: {  //导出Excel表格的表头设置
        'id': 'id',
        '编码': 'code',
        '描述': 'name',
      },
      tableColumn: [{
        label: this.$t('mubandianbianma'),
        prop: 'code',
      }, {
        label: this.$t('miaoshu'),
        prop: 'desc',
      },
        {
          label: this.$t('shifoukexiugai'),
          prop: 'shifoukexiugai'
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('mubandiandaoru')
    }
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n
        if (n == true) {
          this.countTableHeight()

        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false)
          this.tableData = []
          this.excel = []
          this.$refs['excel-upload-input'].value = null
        }
      },
      immediate: false
    },
    allData(val, oldV) {
      console.log(val.length, oldV.length)
      if (val.length > 0) {
        setTimeout(() => {
          this.$refs.downloadBtn.$el.click()
        }, 10) //监听导出数据，判断满足条件等一下下触发导出点击事件
      } else {
        this.$confirm("未找到数据")
      }
    }
  },
  methods: {
    countTableHeight() {
      this.tableHeight = 0
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10
        } else {
          this.tableHeight = 110
        }
      })
    },
    exportModel() {
      return this.http.get('/web/customer/files/downloadByKey?key=shujuxieyimubandiandaorumuban').then(res => {
        const baseUrl = res.data
        if (res.data) {
          window.open(baseUrl)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    importData() {
      const data = [...this.tableData]
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'))
        return;
      }
      for (let i = 0; i < data.length; i++) {
        console.log('jjjjj', this.customerId)
        data[i]['templateId'] = this.templateId;
        data[i]['customerId'] = this.customerId;

        if (data[i]['shifoukexiugai'] == this.$t('shi')) {
          data[i]['modifiable'] = 1;
        } else if (data[i]['shifoukexiugai'] == this.$t('fou')) {
          data[i]['modifiable'] = 0;
        } else if (data[i]['shifoukexiugai'] == null || data[i]['shifoukexiugai'] == undefined) {
          data[i]['modifiable'] = 0;

        }

        delete data[i]['excel']
      }
      return this.http.post('/web/config/customer/equipment/template/point/batchImport', data).then(response => {
        this.utils.successMessage(this.$t(response.msg));
        this.show = false;
        // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
        this.utils.event_hub.$emit('EQUIPMENT_TEMPLATE_POINT_REFRESH');
      }).catch(error => {
        this.utils.errorMessage(this.$t(error));
      })
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({
                   header,
                   results,
                   name
                 }) {
      const data = []
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          }
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']] !== undefined && results[i][this.tableColumn[j]['label']] !== '') {
              this.$set(
                  item,
                  this.tableColumn[j]['prop'],
                  results[i][this.tableColumn[j]['label']]
              )
            }
          }
          console.log(item['code'])
          if (item['code'] !== '' && item['code'] !== undefined) {
            data.push(item)
          }
        }
      }
      this.tableData = this.tableData.concat(data)
      this.excel.push(name)
      this.countTableHeight()
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {

      const files = e.target.files
      console.log(e)
      for (let i = 0; i < files.length; i++) {
        console.log(files[i])
        this.beforeUpload(files[i])
      }

      document.getElementById('templatePointFileInput').value = ''


    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false
      }
      this.readerData(rawFile)
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      this.loading = true
      const reader = new FileReader()
      reader.onload = (e) => {
        const name = rawFile.name
        const data = e.target.result
        const workbook = XLSX.read(data, {
          type: 'array'
        })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const header = this.getHeaderRow(worksheet)
        const results = XLSX.utils.sheet_to_json(worksheet)
        this.generateData({
          header,
          results,
          name
        })
        this.loading = false
      }
      reader.readAsArrayBuffer(rawFile)
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })]
        let hdr = 'UNKNOWN ' + C
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.PageSize = val
      this.pagination.currentPage = 1
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter((item) => {
        return item !== name
      })
      this.tableData = this.tableData.filter((item) => {
        return item.excel !== name
      })
      console.log("excel:", this.excel)
      console.log('tableData:', this.tableData)
      console.log('tableColumn', this.tableColumn)
    },

  }
}
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

</style>
